<template>
  <el-dialog :visible.sync="showCodeBox" width="400px" class="scanCodeBoxPage" :before-close="handleClose">
    <div class="code-detail-box flex-xy">
      <div class="code-title">扫码转账充值</div>
      <div class="code-image">
        <img src="~@/assets/images/default/scanCode.png"/>
      </div>
      <div class="code-tip">
        扫码转账成功后，提供付款截图给客服或您的对接商务即可
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      showCodeBox: false,
    }
  },
  mounted() {
    this.showCodeBox = true;
  },
  methods: {
    handleClose(){
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-xy {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.scanCodeBoxPage {
  ::v-deep .el-dialog__header {
    border: 0 !important;
    background: transparent !important;
    border-radius: 0 !important;
  }
  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #999999 !important;
  }
  ::v-deep .el-dialog__headerbtn {
    font-size: 20px !important;
  }
  ::v-deep .el-dialog__body {
    border-radius: 0 !important;
    background: transparent !important;
    padding: 0 !important;
    margin-top: -22px !important;
  }
  ::v-deep .el-dialog {
    border-radius: 12px !important;
    background: url("~@/assets/images/default/code-bg.png") no-repeat !important;
    background-size: 100% 100% !important;
    height: 407px !important;
    margin-top: 24vh !important;
  }
  .code-detail-box {
    .code-title {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: center;
    }
    .code-image {
      margin-top: 16px;
      width: 300px;
      height: 271px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .code-tip {
      margin-top: 12px;
      line-height: 17px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      text-align: center;
    }
  }
}
</style>